import React from "react";
import "./Join.sass";

export default function Join() {
  return (
    <div className="join">
      <div className="join-container">
        <div className="join-bg">
          <div className="join-title">
            <h2>
              The <strong>perfect world</strong> has been formed with eternal
              gains based on an economy backed by <strong>TENDIES</strong> and
              further stabilized by the <strong>FrenDAO’s ability</strong> to
              maintain order.{" "}
            </h2>
          </div>
          <div className="join-text">
            <br className="mobile" />
            <h2>
              <strong>The agreement </strong>of not giving into{" "}
              <strong>Bezos or Zuck</strong> by <strong>never selling</strong>
              their Secret Internet Computer Monies provides additional
              assurance that the Frens will never be put into a Wage Cage again.
              Kek has created a system by which all Frens never need to work
              again and are rewarded for playing his game. The strongest shill
              army has been assembled incentivized by TENDIES as their war
              ration payment system.
            </h2>
          </div>
        </div>
        <div className="join-bg-2">
          <div className="join-container-2">
            <div className="join-button">
              <button>
                <a href="https://discord.gg/onlyfrens">JOIN NOW</a>
              </button>
            </div>
            <div className="join-button-help">
              <h2>
                <strong>AND HELP THE FRENS WIN THEIR BATTLE!</strong>
              </h2>
            </div>
          </div>
          <div className="join-footer">
            <h2>
              Uncle Elon must access the Halls of Amenti before it’s too late.
              The prophecy states in this place are the Sons of Amenti, who hold
              the blueprints for the Arc Reactor. A powerful device containing
              Kek’s Glorious GIF powers sure to breath life into the MechaFrens!
            </h2>
          </div>
        </div>
        <div className="join-elon"></div>
      </div>
    </div>
  );
}
